import { environment } from 'src/environments/environment';
import { BrowserCacheLocation, InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { MsalGuardConfiguration } from './msal-guard-config';
import { MsalInterceptorConfig } from './msal-interceptor-config';


export function MSALInstanceFactory(): IPublicClientApplication {
  return publicClient;
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfig {
 
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(environment.msal.protectedResources.ocmApi.endpoint, environment.msal.protectedResources.ocmApi.scopes);
  protectedResourceMap.set(environment.msal.protectedResources.reportApi.endpoint, environment.msal.protectedResources.reportApi.scopes);
  protectedResourceMap.set(environment.msal.protectedResources.authApi.endpoint, environment.msal.protectedResources.authApi.scopes);
  protectedResourceMap.set(environment.msal.protectedResources.chatApi.endpoint, environment.msal.protectedResources.chatApi.scopes);
  protectedResourceMap.set(environment.msal.protectedResources.curnexApi.endpoint, environment.msal.protectedResources.curnexApi.scopes);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export const guardConfig: MsalGuardConfiguration = { interactionType: InteractionType.Redirect };

export const interseptorConfig: MsalInterceptorConfig = {
  interactionType: InteractionType.Redirect,
  protectedResourceMap: new Map([
    [environment.msal.protectedResources.ocmApi.endpoint, environment.msal.protectedResources.ocmApi.scopes],
    [environment.msal.protectedResources.reportApi.endpoint, environment.msal.protectedResources.reportApi.scopes],
    [environment.msal.protectedResources.authApi.endpoint, environment.msal.protectedResources.authApi.scopes],
    [environment.msal.protectedResources.chatApi.endpoint, environment.msal.protectedResources.chatApi.scopes],
    [environment.msal.protectedResources.curnexApi.endpoint, environment.msal.protectedResources.curnexApi.scopes]
  ])
};



const publicClient = new PublicClientApplication({
  auth: {
    clientId: environment.msal.clientId,
    authority: environment.msal.signinAuthority,
    redirectUri: environment.msal.redirectUri,
    knownAuthorities: environment.msal.knownAuthorities,
    postLogoutRedirectUri:environment.msal.logOutUri    
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage,
    storeAuthStateInCookie: false, // set to true for IE 11
  },
  system: {
    loggerOptions: {
      loggerCallback: () => { },
      piiLoggingEnabled: false
    }
  }
});
